'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRANSLATION_FETCH_REQUESTED = exports.TRANSLATION_FETCH_REQUESTED = '@wh/translation-tokens/TRANSLATION_FETCH_REQUESTED';
var TRANSLATION_FETCH_SUCCEEDED = exports.TRANSLATION_FETCH_SUCCEEDED = '@wh/translation-tokens/TRANSLATION_FETCH_SUCCEEDED';
var TRANSLATION_FETCH_FAILED = exports.TRANSLATION_FETCH_FAILED = '@wh/translation-tokens/TRANSLATION_FETCH_FAILED';
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/translation-tokens/dist/main/constants.js
// module id = 180
// module chunks = 0